var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "confirm",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isShow,
          expression: "isShow"
        }
      ],
      attrs: {
        showMask: true,
        title: _vm.confirmTitle,
        closeIcon: true,
        close: _vm.close,
        leftBtnClick: _vm._openVIP,
        leftBtnTxt: _vm.confirmTitle,
        singleBtn: true,
        btnUnuse: !_vm.canOrder,
        isLoading: _vm.isLoading
      }
    },
    [
      _c("div", { staticClass: "__row" }, [
        _c("div", { staticClass: "__row_t" }, [
          _vm._v(_vm._s(_vm.$t("tokenCard.heads.availableExAmount")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "__input_row __unuse_input __bold" }, [
          _c("img", {
            staticClass: "__icon",
            attrs: { src: _vm.viteTokenInfo ? _vm.viteTokenInfo.icon : "" }
          }),
          _vm._v("dSLS\n            "),
          _c("span", { staticClass: "__right" }, [
            _vm._v(_vm._s(_vm.exViteBalance))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "__row" }, [
        _c("div", { staticClass: "__row_t" }, [
          _vm._v(_vm._s(_vm.stakingText) + "\n            "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.canOrder,
                  expression: "!canOrder"
                }
              ],
              staticClass: "__err"
            },
            [_vm._v(_vm._s(_vm.$t("tradeVip.vipConfirm.noBalance")))]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "__input_row __unuse_input" }, [
          _vm._v("10,000 dSLS")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "__row" }, [
        _c("div", { staticClass: "__row_t" }, [
          _vm._v(_vm._s(_vm.$t("tradeVip.vipConfirm.address")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "__input_row __unuse_input" }, [
          _vm._v(_vm._s(_vm.accountAddr))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "__hint" }, [
        _c("span", [_vm._v(_vm._s(_vm.hint))])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }